import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Lightbox from "./components/Lightbox";
import PageTransition from "./components/PageTransition";
import Seo from "./components/Seo";
import DashboardPage from "./pages/DashboardPage";
import HomePage from "./pages/HomePage";
import { DatenschutzPage, ImpressumPage } from "./pages/LegalPage";
import MenuPage from "./pages/MenuPage";
import ReservePage from "./pages/ReservePage";

export default function App() {
  const location = useLocation();

  // A new route starts at the top; an in-page anchor (#hours) is left alone.
  useEffect(() => {
    if (!location.hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return (
    <>
    <Seo />
    <Lightbox />
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
        <Route path="/menu" element={<PageTransition><MenuPage /></PageTransition>} />
        <Route path="/reserve" element={<PageTransition><ReservePage /></PageTransition>} />
        <Route path="/impressum" element={<PageTransition><ImpressumPage /></PageTransition>} />
        <Route path="/datenschutz" element={<PageTransition><DatenschutzPage /></PageTransition>} />
        {/* Staff only; deliberately not in the nav. */}
        <Route path="/dashboard" element={<PageTransition><DashboardPage /></PageTransition>} />
        <Route path="*" element={<PageTransition><HomePage /></PageTransition>} />
      </Routes>
    </AnimatePresence>
    </>
  );
}
